import React, { Component, ChangeEvent } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import Artwork from '../../model/artwork';
import ArtworkMasonry from './ArtworkMasonry';
import { getLangData, getElementFrom } from "../../services/lang";
import Slider from '@material-ui/core/Slider';
import StrapiResponse from '../../model/strapiResponse';
import { getArtworks } from '../../services/strapiService';
import qs from 'qs';
import { StaticContext } from 'react-router';

type CatalogueState = {
    isLoading: boolean;
    isSearching: boolean;
    hasError: boolean;
    selectedTypeOfObject: Array<string>;
    selectedKeywords: Array<string>;
    selectedMaterial: Array<string>;
    selectedSupport: Array<string>;
    selectedDates: Array<string>;
    selectedHeight: Array<number>;
    selectedWidth: Array<number>;
    artworks: Array<Artwork>;
    artworksCount: number;
    page: number;
    pageCount: number;
};

export default class Catalogue extends Component<RouteComponentProps, CatalogueState>  {

    static tooUrlKey = 'typeOfObject';
    static tofType = 'filterTypeOfObject';
    static tofValues = [
        "painting",
        "collage",
        "drawing",
        "print",
        "book",
        "newspaperClipping",
        "sketchbook",
        "pamphlet",
        "paper",
        "photocopy",
        "photograph",
        "postcard",
        "puppets",
        "writing",
    ];
    static keywordsUrlKey = 'keywords';
    static keywordsType = 'filterKeywords';
    static keywordsValues = [
        "figurative",
        "portrait",
        "stillLife",
        "landscape",
        "text",
        "abstract",
    ];
    static materialsUrlKey = 'materials';
    static materialType = 'filterMaterial';
    static materialValues = [
        "oil",
        "pencil",
        "pen",
        "charcoal",
        "gouache",
        "watercolour",
        "pastel",
        "ink",
        "eggTempera",
        "paper",
        "organicMatter",
    ];
    static supportUrlKey = 'support';
    static supportType = 'filterSupport';
    static supportValues = [
        "canvas",
        "paper",
        "board",
        "glass",
    ];
    static dateUrlKey = 'dates';
    static dateType = 'filterDate';
    static dates = [
        '1920s',
        '1930s',
        '1940s',
        '1950s',
        '1960s',
        '1970s',
        '1980s',
        '1990s',
        '2000s',
        '2010s'
    ];
    static heightUrlKey = 'height';
    static heightType = 'filterHeight';
    static widthUrlKey = 'width';
    static widthType = 'filterWidth';
    static pageUrlKey = 'page';

    static defaulState: CatalogueState = {
        isLoading: true,
        isSearching: false,
        hasError: false,
        selectedTypeOfObject: [],
        selectedKeywords: [],
        selectedMaterial: [],
        selectedSupport: [],
        selectedDates: [],
        selectedHeight: [3, 100],
        selectedWidth: [3, 100],
        artworks: [],
        artworksCount: 0,
        page: 1,
        pageCount: 0,
    };

    constructor(props: Readonly<RouteComponentProps>) {
        super(props);

        this.state = Catalogue.defaulState;

        this.parseUrlQuery = this.parseUrlQuery.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSliderChange = this.handleSliderChange.bind(this);
        this.clearAllFilters = this.clearAllFilters.bind(this);
        this.clearFilter = this.clearFilter.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.loadArtworks = this.loadArtworks.bind(this);
        this.goToPage = this.goToPage.bind(this);
    }

    componentDidMount() {
        this.parseUrlQuery(this.applyFilter);
    }

    componentDidUpdate(prevProps: Readonly<RouteComponentProps<{}, StaticContext, unknown>>): void {
        if (this.props.location !== prevProps.location) {
            this.parseUrlQuery(this.applyFilter);
        }
    }

    /**
     * https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html
     * @param nextProps 
     */
    UNSAFE_componentWillReceiveProps(nextProps: Readonly<RouteComponentProps<{}>>) {
        if (nextProps.location.state === 'desiredState') {
            this.clearAllFilters();
        }
    }

    handleInputChange(event: ChangeEvent<HTMLInputElement>) {
        const target: EventTarget & HTMLInputElement = event.currentTarget;
        if (target.type !== 'checkbox') return;
        const value: boolean = target.checked;
        const name: string = target.name;
        const filterType: string | null = target.getAttribute('data-filtertype');
        if (filterType !== null && value) {
            if (filterType === Catalogue.tofType) {
                const typeOfObjects = this.state.selectedTypeOfObject;
                typeOfObjects.push(name);
                this.setState({ selectedTypeOfObject: typeOfObjects } as CatalogueState);
            } else if (filterType === Catalogue.keywordsType) {
                const keywords = this.state.selectedKeywords;
                keywords.push(name);
                this.setState({ selectedKeywords: keywords } as CatalogueState);
            } else if (filterType === Catalogue.materialType) {
                const materials = this.state.selectedMaterial;
                materials.push(name);
                this.setState({ selectedMaterial: materials } as CatalogueState);
            } else if (filterType === Catalogue.supportType) {
                const supports = this.state.selectedSupport;
                supports.push(name);
                this.setState({ selectedSupport: supports } as CatalogueState);
            } else if (filterType === Catalogue.dateType) {
                const dates = this.state.selectedDates;
                dates.push(name);
                this.setState({ selectedDates: dates } as CatalogueState);
            }
        } else if (filterType !== null && !value) {
            if (filterType === Catalogue.tofType) {
                let typeOfObjects = this.state.selectedTypeOfObject;
                typeOfObjects = typeOfObjects.filter(tof => tof !== name);
                this.setState({ selectedTypeOfObject: typeOfObjects } as CatalogueState);
            } else if (filterType === Catalogue.keywordsType) {
                let keywords = this.state.selectedKeywords;
                keywords = keywords.filter(k => k !== name);
                this.setState({ selectedKeywords: keywords } as CatalogueState);
            } else if (filterType === Catalogue.materialType) {
                let materials = this.state.selectedMaterial;
                materials = materials.filter(m => m !== name);
                this.setState({ selectedMaterial: materials } as CatalogueState);
            } else if (filterType === Catalogue.supportType) {
                let supports = this.state.selectedSupport;
                supports = supports.filter(s => s !== name);
                this.setState({ selectedSupport: supports } as CatalogueState);
            } else if (filterType === Catalogue.dateType) {
                let dates = this.state.selectedDates;
                dates = dates.filter(d => d !== name);
                this.setState({ selectedDates: dates } as CatalogueState);
            }
        }
    }

    handleSliderChange(value: number | number[], type: string) {
        let arrValue: Array<number> = [];
        if (typeof value === "number") {
            arrValue = [value, value];
        } else {
            arrValue = value;
        }
        switch (type) {
            case "height":
                this.setState({ selectedHeight: arrValue });
                break;
            case "width":
                this.setState({ selectedWidth: arrValue });
                break;
        }
    }

    goToPage(page: number) {
        this.setState({
            isLoading: true,
            page: page,
        }, this.loadArtworks);
    }

    clearAllFilters() {
        this.setState({
            selectedTypeOfObject: [],
            selectedKeywords: [],
            selectedMaterial: [],
            selectedSupport: [],
            selectedDates: [],
            selectedHeight: [3, 100],
            selectedWidth: [3, 100],
            page: 1,
        }, this.applyFilter);
    }

    clearFilter(elem: string, type: string) {
        const {
            selectedTypeOfObject,
            selectedKeywords,
            selectedMaterial,
            selectedSupport,
            selectedDates
        } = this.state;
        if (type === Catalogue.tofType) {
            this.setState({
                selectedTypeOfObject: selectedTypeOfObject.filter(tof => tof !== elem),
                page: 1,
            } as CatalogueState,
                this.applyFilter,
            );
        } else if (type === Catalogue.keywordsType) {
            this.setState({
                selectedKeywords: selectedKeywords.filter(k => k !== elem),
                page: 1
            } as CatalogueState,
                this.applyFilter,
            );
        } else if (type === Catalogue.materialType) {
            this.setState({
                selectedMaterial: selectedMaterial.filter(m => m !== elem),
                page: 1
            } as CatalogueState,
                this.applyFilter,
            );
        } else if (type === Catalogue.supportType) {
            this.setState({
                selectedSupport: selectedSupport.filter(s => s !== elem),
                page: 1
            } as CatalogueState,
                this.applyFilter,
            );
        } else if (type === Catalogue.dateType) {
            this.setState({
                selectedDates: selectedDates.filter(d => d !== elem),
                page: 1
            } as CatalogueState,
                this.applyFilter,
            );
        } else if (type === Catalogue.heightType) {
            this.setState({
                selectedHeight: [3, 100],
                page: 1

            }, this.applyFilter);
        } else if (type === Catalogue.widthType) {
            this.setState({
                selectedWidth: [3, 100],
                page: 1

            }, this.applyFilter);
        }
    }

    applyFilter() {
        this.setState({
            isSearching: true,
            artworks: [],
            artworksCount: 0,
            pageCount: 0,
        }, this.loadArtworks);
    }

    async loadArtworks(page: number = this.state.page) {
        this.setState({ isLoading: true });
        try {
            const strapiRes: StrapiResponse<Artwork> = await getArtworks(
                {
                    typeOfObject: this.state.selectedTypeOfObject,
                    keywords: this.state.selectedKeywords,
                    material: this.state.selectedMaterial,
                    support: this.state.selectedSupport,
                    date: this.state.selectedDates,
                    height: this.state.selectedHeight,
                    width: this.state.selectedWidth,
                },
                page,
            );
            this.setState({
                artworks: strapiRes.entries,
                artworksCount: strapiRes.entriesCount,
                page: strapiRes.page,
                pageCount: strapiRes.pageCount,
                isLoading: false,
                isSearching: false,
            });
        } catch (e) {
            console.error(e);
            this.setState({
                isLoading: false,
                isSearching: false,
                hasError: true,
            });
        }
        this.updateUrlSearchParams();
    }

    parseUrlQuery(callback: () => void): void {
        let selectedTypeOfObject: Array<string> = [];
        let selectedKeywords: Array<string> = [];
        let selectedMaterial: Array<string> = [];
        let selectedSupport: Array<string> = [];
        let selectedDates: Array<string> = [];
        let selectedHeight: Array<number> = [3, 100];
        let selectedWidth: Array<number> = [3, 100];
        let selectedPage: number = 1;

        const params: qs.ParsedQs = qs.parse(this.props.location.search, { comma: true, ignoreQueryPrefix: true });
        for (const key in params) {
            const val = params[key];
            if (val === undefined) continue;
            const value: string | Array<string> = val as string | Array<string>;
            if (key === Catalogue.tooUrlKey) {
                selectedTypeOfObject = this.validateFilterOptions(value, Catalogue.tofValues);
            } else if (key === Catalogue.keywordsUrlKey) {
                selectedKeywords = this.validateFilterOptions(value, Catalogue.keywordsValues);
            } else if (key === Catalogue.materialsUrlKey) {
                selectedMaterial = this.validateFilterOptions(value, Catalogue.materialValues);
            } else if (key === Catalogue.supportUrlKey) {
                selectedSupport = this.validateFilterOptions(value, Catalogue.supportValues);
            } else if (key === Catalogue.dateUrlKey) {
                selectedDates = this.validateFilterOptions(value, Catalogue.dates);
            } else if (key === Catalogue.heightUrlKey) {
                selectedHeight = this.validateLengths(value, [3, 100]);
            } else if (key === Catalogue.widthUrlKey) {
                selectedWidth = this.validateLengths(value, [3, 100]);
            } else if (key === Catalogue.pageUrlKey) {
                selectedPage = this.validatePage(value);
            }
        }
        this.setState({
            selectedTypeOfObject: selectedTypeOfObject,
            selectedKeywords: selectedKeywords,
            selectedMaterial: selectedMaterial,
            selectedSupport: selectedSupport,
            selectedDates: selectedDates,
            selectedHeight: selectedHeight,
            selectedWidth: selectedWidth,
            page: selectedPage,
        }, callback);
    }

    validateFilterOptions(input: string | Array<string>, allowedValues: Array<string>): Array<string> {
        let inputArr: Array<string> = input instanceof Array ?
            input : [input as string];
        return inputArr
            .filter(x => x.trim().length > 0 && allowedValues.some(y => x.toUpperCase() === y.toUpperCase()));
    }

    validateLengths(input: string | Array<string>, defaultArr: Array<number>): Array<number> {
        let inputArr: Array<string> = input instanceof String ?
            [input as string] : input as Array<string>;
        let numArr: Array<number> = inputArr.map(v => Number(v));
        if (numArr.some(v => isNaN(v))) {
            return defaultArr;
        } else if (numArr.length < 2) {
            return defaultArr;
        }
        numArr = numArr.sort();
        if (numArr.length > 2) {
            numArr = [numArr[0], numArr.pop() ?? defaultArr[1]];
        }
        if (numArr[0] < defaultArr[0]) {
            numArr[0] = defaultArr[0];
        }
        if (numArr[1] > defaultArr[1]) {
            numArr[1] = defaultArr[1];
        }
        return numArr;
    }

    validatePage(input: string | Array<string>): number {
        const inputStr: string | undefined = input instanceof Array ? input.pop() : input;
        if (inputStr === undefined || inputStr.length === 0) return 1;
        const page = Number.parseInt(inputStr);
        return isNaN(page) || page < 1 ? 1 : page;
    }

    updateUrlSearchParams() {
        const params: qs.ParsedQs = qs.parse(window.location.search, { comma: true, ignoreQueryPrefix: true });
        params[Catalogue.tooUrlKey] = this.state.selectedTypeOfObject;
        params[Catalogue.keywordsUrlKey] = this.state.selectedKeywords;
        params[Catalogue.materialsUrlKey] = this.state.selectedMaterial;
        params[Catalogue.supportUrlKey] = this.state.selectedSupport;
        params[Catalogue.dateUrlKey] = this.state.selectedDates;
        params[Catalogue.heightUrlKey] =
            this.state.selectedHeight.includes(3) && this.state.selectedHeight.includes(100)
                ? undefined
                : this.state.selectedHeight.map(d => d.toFixed(0));
        params[Catalogue.widthUrlKey] =
            this.state.selectedWidth.includes(3) && this.state.selectedWidth.includes(100)
                ? undefined
                : this.state.selectedWidth.map(d => d.toFixed(0));
        params[Catalogue.pageUrlKey] = this.state.page === 1 ? undefined : this.state.page.toFixed(0);
        const paramsString: string = qs.stringify(params,
            {
                addQueryPrefix: true,
                arrayFormat: 'comma',
                encodeValuesOnly: true
            });
        if (paramsString !== window.location.search) this.props.history.push(window.location.pathname + paramsString);
    }

    render() {

        const {
            artworks,
            isLoading: isCatalogueLoading,
            isSearching,
            selectedTypeOfObject,
            selectedKeywords,
            selectedMaterial,
            selectedSupport,
            selectedDates,
            selectedHeight,
            selectedWidth,
        } = this.state;
        const langData = getLangData();

        if (isCatalogueLoading) {
            return this.buildLoadingIndicator();
        }

        const filterTypeOfObjectCheckboxes = Catalogue.tofValues.map(tof => FilterCheckbox(
            this,
            tof,
            Catalogue.tofType,
            selectedTypeOfObject.includes(tof)));
        const filterKeywordsCheckboxes = Catalogue.keywordsValues.map(k => FilterCheckbox(
            this,
            k,
            Catalogue.keywordsType,
            selectedKeywords.includes(k)));
        const filterMaterialCheckboxes = Catalogue.materialValues.map(m => FilterCheckbox(
            this,
            m,
            Catalogue.materialType,
            selectedMaterial.includes(m)));
        const filterSupportCheckboxes = Catalogue.supportValues.map(s => FilterCheckbox(
            this,
            s,
            Catalogue.supportType,
            selectedSupport.includes(s)));
        const filterDateCheckboxes = Catalogue.dates.map(d => FilterCheckbox(
            this,
            d,
            Catalogue.dateType,
            selectedDates.includes(d)));

        const tofDisclaimer = selectedTypeOfObject.map(tof => FilterDisclaimer(this, tof, Catalogue.tofType));
        const keywordsDisclaimer = selectedKeywords.map(k => FilterDisclaimer(this, k, Catalogue.keywordsType));
        const materialDisclaimer = selectedMaterial.map(m => FilterDisclaimer(this, m, Catalogue.materialType));
        const supportDisclaimer = selectedSupport.map(s => FilterDisclaimer(this, s, Catalogue.supportType));
        const dateDisclaimer = selectedDates.map(d => FilterDisclaimer(this, d, Catalogue.dateType));
        const heightDisclaimer = selectedHeight[0] === 3 && selectedHeight[1] === 100 ? '' :
            FilterDisclaimer(this, selectedHeight[0] + 'cm - ' + selectedHeight[1] + 'cm', Catalogue.heightType);
        const widthDisclaimer = selectedWidth[0] === 3 && selectedWidth[1] === 100 ? '' :
            FilterDisclaimer(this, selectedWidth[0] + 'cm - ' + selectedWidth[1] + 'cm', Catalogue.widthType);

        const filterDisclaimer = <div className="row">
            <div className="col">
                {tofDisclaimer}
                {keywordsDisclaimer}
                {materialDisclaimer}
                {supportDisclaimer}
                {dateDisclaimer}
                {heightDisclaimer}
                {widthDisclaimer}
            </div>
        </div>;


        return (
            < div className="container">

                <div className="row mb-5">
                    <div className="col">
                        <p className="h1 fw-300">{langData.catalogue.header}</p>
                    </div>
                </div>

                <div className="row mb-2 d-flex justify-content-end">
                    <div className="col-4 col-md-3 col-lg-2 col-xl-2">
                        <button
                            className="btn btn-block btn-outline-dark"
                            type="button"
                            data-toggle="collapse"
                            data-target="#filterCollapse"
                        >{langData.catalogue.filter} <span className="ti-angle-down" /></button>
                    </div>
                </div>

                {filterDisclaimer}

                {this.buildFilterBox(
                    filterTypeOfObjectCheckboxes,
                    filterMaterialCheckboxes,
                    filterSupportCheckboxes,
                    filterKeywordsCheckboxes,
                    filterDateCheckboxes,
                    selectedHeight,
                    selectedWidth,
                )}

                {isSearching
                    ? this.buildLoadingIndicator()
                    : this.buildResult(artworks)
                }

            </div >
        );
    }

    buildFilterBox(
        filterTypeOfObjectCheckboxes: JSX.Element[],
        filterMaterialCheckboxes: JSX.Element[],
        filterSupportCheckboxes: JSX.Element[],
        filterKeywordsCheckboxes: JSX.Element[],
        filterDateCheckboxes: JSX.Element[],
        selectedHeight: Array<number>,
        selectedWidth: Array<number>,
    ): JSX.Element {
        const langData = getLangData();
        return (
            <div className="row mb-4 pb-4 border-bottom">
                <div className="collapse col-12" id="filterCollapse">
                    <div className="card card-body">
                        <div className="row mb-4">
                            <div className="col-12 col-md-6 col-lg-3 col-xl-3 mb-4">
                                <p>{langData.catalogue.typeOfObject}</p>
                                {filterTypeOfObjectCheckboxes}
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 col-xl-3 mb-4">
                                <p>{langData.catalogue.material}</p>
                                {filterMaterialCheckboxes}
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 col-xl-3 mb-4">
                                <p>{langData.catalogue.support}</p>
                                {filterSupportCheckboxes}
                                <div className="mb-4" />
                                <p>{langData.catalogue.keywords}</p>
                                {filterKeywordsCheckboxes}
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 col-xl-3 mb-4">
                                <p>{langData.catalogue.date}</p>
                                {filterDateCheckboxes}
                            </div>
                        </div>
                        <div className="row mb-4 justify-content-center">
                            <div className="col-8">
                                <p className="mb-1">{langData.catalogue.height}</p>
                                <Slider
                                    name="height"
                                    value={selectedHeight}
                                    onChange={(_event, value) => this.handleSliderChange(value, "height")}
                                    valueLabelDisplay="auto"
                                    valueLabelFormat={(val: number) => { return val + "cm"; }}
                                    min={3}
                                    max={100}
                                    step={1}
                                />
                            </div>
                            <div className="col-8">
                                <p className="mb-1">{langData.catalogue.width}</p>
                                <Slider
                                    name="width"
                                    value={selectedWidth}
                                    onChange={(_event, value) => this.handleSliderChange(value, "width")}
                                    valueLabelDisplay="auto"
                                    valueLabelFormat={(val: number) => { return val + "cm"; }}
                                    min={3}
                                    max={100}
                                    step={1}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col d-flex justify-content-end">
                                <button
                                    className="btn btn-outline-dark mr-3"
                                    type="button" data-toggle="collapse"
                                    data-target="#filterCollapse"
                                    onClick={() => this.setState({ page: 1 }, this.applyFilter)}
                                >
                                    {langData.meta.apply}
                                </button>
                                <button className="btn btn-outline-dark" type="button" onClick={this.clearAllFilters}>
                                    {langData.meta.clearAll}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildResult(artworks: Array<Artwork>): JSX.Element {
        const langData = getLangData();
        return (
            <div className="noOverflowAnchor" >
                <p className='text-muted'>{this.state.artworksCount} {langData.meta.results}</p>
                {
                    artworks.length > 0 ?
                        this.buildArtworkMasonries(artworks) :
                        <div className="container d-flex justify-content-center align-items-center mb-5">
                            <p className="lead">{langData.meta.noArtworksFound}</p>
                        </div>
                }
                {this.buildPagination()}
            </div >
        );
    }

    buildLoadingIndicator() {
        const langData = getLangData();
        return (
            <div className="row mb-5">
                <div className="col d-flex justify-content-center align-items-center">
                    <div className="spinner-border mr-3" role="status" />{langData.meta.isLoading}
                </div>
            </div>
        );
    }

    buildArtworkMasonries(artworks: Array<Artwork>): JSX.Element {
        return (
            <div className="row" >
                {
                    < ArtworkMasonry artworks={artworks} />
                }
            </div >
        );
    }

    buildPagination(): JSX.Element {
        const {
            page,
            pageCount,
        } = this.state;
        const pages: Array<JSX.Element> = [];
        for (let p = Math.max(1, page - 2); p <= Math.min(pageCount, page + 2); p++) {
            pages.push(
                <button
                    type='button'
                    className={`btn btn-outline-dark ${page === p ? 'active' : ''}`}
                    key={`page-${p}`}
                    onClick={() => this.goToPage(p)}>
                    {p}
                </button>
            )
        }
        return (
            <div className='d-flex justify-content-center mb-3'>
                <nav className='btn-toolbar' role='toolbar'>
                    {1 < page - 2
                        ? <div className='btn-group mr-3' role='group'>
                            <button
                                type='button'
                                className='btn btn-outline-dark'
                                onClick={() => this.goToPage(1)}>1</button>
                        </div>
                        : undefined}
                    <div className='btn-group' role='group'>
                        {pages}
                    </div>
                    {pageCount > page + 2
                        ? <div className='btn-group ml-3' role='group'>
                            <button
                                type='button'
                                className='btn btn-outline-dark'
                                onClick={() => this.goToPage(pageCount)}>{pageCount}</button>
                        </div>
                        : undefined}
                </nav>
            </div>
        )
    }

}

function FilterCheckbox(that: Catalogue, elem: string, type: string, isChecked: boolean) {

    const langData = getLangData().catalogue;
    let displayString;
    if (type === Catalogue.tofType) {
        displayString = getElementFrom(langData.typeOfObjectValues, elem);
    } else if (type === Catalogue.keywordsType) {
        displayString = getElementFrom(langData.keywordsValues, elem);
    } else if (type === Catalogue.materialType) {
        displayString = getElementFrom(langData.materialValues, elem);
    } else if (type === Catalogue.supportType) {
        displayString = getElementFrom(langData.supportValues, elem);
    } else if (type === Catalogue.dateType) {
        displayString = elem;
    }

    return <div className="custom-control custom-checkbox" key={elem}>
        <input
            type="checkbox"
            className="custom-control-input"
            id={type + '-' + elem}
            name={elem}
            data-filtertype={type}
            onChange={that.handleInputChange}
            checked={isChecked} />
        <label className="custom-control-label" htmlFor={type + '-' + elem}>{displayString}</label>
    </div>;
}

function FilterDisclaimer(that: Catalogue, elem: string, type: string) {
    const langData = getLangData().catalogue;
    let displayString;
    if (type === Catalogue.tofType) {
        displayString = getElementFrom(langData.typeOfObjectValues, elem);
    } else if (type === Catalogue.keywordsType) {
        displayString = getElementFrom(langData.keywordsValues, elem);
    } else if (type === Catalogue.materialType) {
        displayString = getElementFrom(langData.materialValues, elem);
    } else if (type === Catalogue.supportType) {
        displayString = getElementFrom(langData.supportValues, elem);
    } else if (type === Catalogue.heightType) {
        displayString = langData.height + ': ' + elem;
    } else if (type === Catalogue.widthType) {
        displayString = langData.width + ': ' + elem;
    } else if (type === Catalogue.dateType) {
        displayString = elem;
    }
    return (
        <span
            className="badge badge-pill badge-light border-black mr-2 mb-2 fw-300"
            key={type + elem}>
            {displayString}
            <button
                className="btn btn-link p-0 ml-1"
                onClick={() => that.clearFilter(elem, type)}
            >&times;</button></span>
    );
}
